import React from 'react';
import { Tooltip } from 'react-tooltip';

import { ReactComponent as CopyIcon } from '@assets/svg/ic-copyDetails.svg';

import useTranslation from '@hooks/useTranslation';

import { showToast } from '../../../helpers/showToast';
import style from './style.module.scss';

interface IProps {
  id?: string;
  copyDetailsData?: Array<string>;
  tooltipInfo?: string;
}

const ButtonCopyDetails: React.FC<IProps> = ({ id = 'copyDetails', copyDetailsData = [''], tooltipInfo }) => {
  const { t } = useTranslation();

  const copyDetailsInfo = async () => {
    const detailsInfo = copyDetailsData.join('\n');
    const blob = new Blob([detailsInfo], { type: 'text/plain' });
    const data = [new ClipboardItem({ ['text/plain']: blob })];

    await navigator.clipboard.write(data);
    showToast({ variant: 'success', message: t('Successfully copied to clipboard') });
  };

  return (
    <span id={id} className={style.detailsCopyBtn} onClick={copyDetailsInfo}>
      <CopyIcon className={style.detailsCopyBtnSvg} />
      <Tooltip anchorSelect={`#${id}`} content={tooltipInfo} place="right" />
    </span>
  );
};

export default ButtonCopyDetails;
